/** ========================================================================= *\
 * @prefab Sky
 * ========================================================================== */

class Sky extends Phaser.Sprite {

  static skyStates = [
    {
      from: 0,
      to: 20,
      fromColor: 0x56B6DF,
      toColor: 0x56B6DF,
      isActivated: false
    },
    {
      from: 20,
      to: 40,
      fromColor: 0x56B6DF,
      toColor: 0xD8886F,
      isActivated: false
    },
    {
      from: 40,
      to: 60,
      fromColor: 0xD8886F,
      toColor: 0x444472,
      isActivated: false
    },
    {
      from: 60,
      to: 80,
      fromColor: 0x444472,
      toColor: 0x997A6B,
      isActivated: false
    },
    {
      from: 80,
      to: 100,
      fromColor: 0x997A6B,
      toColor: 0xBA5665,
      isActivated: false
    }
  ];


  /** Class Properties ------------------------------------------------------ */
  game = undefined;
  skies = [];

  /** @constructor ---------------------------------------------------------- */
  constructor(game) {
    // Create background
    const bitmap = new Phaser.BitmapData(game, 'skybg', game.width, game.height);
    bitmap.ctx.rect(0, 0, game.width, game.height);
    bitmap.ctx.fillStyle = '#FFFFFF';
    bitmap.ctx.fill();

    // Initialize sprite instance
    super(game, 0, 0, bitmap);
    this.game = game;
    this.fixedToCamera = true;

    // Clone sky states
    this.skies = Sky.skyStates.map(sky => Object.assign({}, sky));

    // Tint to first color
    const initialSkyState = this.skies[0];
    this.tint = initialSkyState.toColor;
  }

  /** Main loop ------------------------------------------------------------- */
  update() {
    const progress = (this.game.progress - this.game.gameSpeedUp);
    this.skies.forEach((state, index) => {
      if (progress > state.from && !state.isActivated) {
        this.skies[index].isActivated = true;
        this.tweenTint(state.fromColor, state.toColor, 3000);
      }
    });
  }

  /** @public Methods ------------------------------------------------------- */
  tweenTint(startColor, endColor, duration) {
    let colorBlend = { step: 0 };
    this.game.add
      .tween(colorBlend)
      .to({ step: 100 }, duration, Phaser.Easing.Default, false)
      .onUpdateCallback(() => {
        this.tint = Phaser.Color.interpolateColor(
          startColor, endColor, 100, colorBlend.step, 1
        );
      })
      .start();
  }
}

export default Sky;



// WEBPACK FOOTER //
// ./js/prefabs/sky.js